import { useQuery } from "@tanstack/react-query"
import { getSearchFilters } from "@/lib/api/search.api"
import { useAuthStore } from "@/store/auth.store"

export function useSearchFilters() {
  const accessToken = useAuthStore((s) => s.accessToken)

  return useQuery({
    queryKey: ["search-filters"],
    queryFn: () => getSearchFilters(accessToken ?? undefined),
    staleTime: 1000 * 60 * 30, // 30 minutes
    refetchOnWindowFocus: false,
  })
}